import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { CerebroTextButton } from '../../shared/components';
import { useApi } from '../../shared/context';
import { QueryKeys } from '../../shared/hooks';
import { CerebroApiEndpoints } from '../../shared/utils/api';
import { getResponseData } from '../../shared/utils/axios';

interface TeaserConfirmationDialogProps {
	dataRoomGuid?: string;
	isOpen: boolean;
	close: () => void;
}

export const TeaserConfirmationDialog: React.FC<TeaserConfirmationDialogProps> = ({ dataRoomGuid, isOpen, close }) => {
	const api = useApi();
	const snackbar = useSnackbar();
	const client = useQueryClient();

	const onConfirmation = () => {
		confirmTeasers();
	};

	const { mutate: confirmTeasers } = useMutation<void, unknown, void>(
		() => getResponseData(api.post<void>(CerebroApiEndpoints.DataRooms.Confirmation(dataRoomGuid))),
		{
			onMutate: () => {
				close();
			},
			onSuccess: () => {
				client.invalidateQueries(QueryKeys.Teasers.Root(dataRoomGuid));
				client.invalidateQueries(QueryKeys.DataRoom.Confirmation(dataRoomGuid));
				snackbar.enqueueSnackbar('Teasers were confirmed.', { variant: 'success' });

				close();
			},
			onError: () => {
				snackbar.enqueueSnackbar('There was a problem confirming the teaser.', { variant: 'error' });
			},
		}
	);

	return (
		<Dialog open={isOpen} onClose={close}>
			<DialogTitle>Confirm Unsent Teasers</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Confirming the teaser list will enable the &quot;Launch Deal&quot; function on this deal. When the
					deal is launched, teasers will be sent to all lenders on the teaser list.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<CerebroTextButton onClick={close}>No</CerebroTextButton>
				<CerebroTextButton onClick={onConfirmation}>Yes</CerebroTextButton>
			</DialogActions>
		</Dialog>
	);
};
